import gameData from "../../gameData";
import { makeDonutStart } from "../makeADonut/makeDonutStart";
import { correctTimeline, donutsOut, incorrectTimeline } from "./tweenTimelines";
import * as ABCya from '@abcya/abcya_phaser';

export function listenerSetup(scene)
{
    scene.events.on("sameClick",(donut)=>{sameClick(scene,donut)});
    scene.events.on("differentClick",(donut)=>{differentClick(scene,donut)});
    scene.events.on("correct",()=>{correct(scene)});
    scene.events.on("incorrect",()=>{incorrect(scene)});
    scene.events.on("complete",()=>{complete(scene)});

    scene.events.on('update',selectorUpdateLoop,scene);
}

function sameClick(scene,donut)
{
    scene.tweens.killTweensOf([scene.selector1, scene.selector2])

    let reset = false;
    let selector;
    if(gameData.clickedState === 0)
    {
        selector = scene.selector1;
        selector.selectedDonut = donut;
        scene.selector2.selectedDonut = null;
        gameData.clickedState = 1;
        // reset the selectors back to 0 to make sure they are in the right state
        scene.selector1.alpha = 0;
        scene.selector2.alpha = 0;
    }
    else
    {
        //if(donut.image.x === scene.selector1.x && donut.yData === scene.selector1.y)
        if(donut === scene.selector1.selectedDonut)
        {
            reset = true;
            scene.selector1.setAlpha(0);
            gameData.clickedState = 0;
        }
        else
        {
            selector = scene.selector2;
            selector.selectedDonut = donut;
            gameData.clickedState = 0;
        }
    }
    
    if(!reset)
    {
        selector.setFrame(donut.selectorFrame);
        //selector.setPosition(donut.image.x,donut.yData);
        selector.setPosition(donut.image.x,donut.image.y);
        setSelectorDonut(gameData.clickedState, donut);
        if(selector.alpha < 1)  selector.setAlpha(1);
        selector.answer = donut.answer;

        if((scene.selector1.alpha === 1) && (scene.selector2.alpha === 1))
        {
            if((scene.selector1.x != scene.selector2.x) || (scene.selector1.y != scene.selector2.y))
            {
                if((scene.selector1.answer) && (scene.selector2.answer))
                {
                    scene.events.emit("correct");
                }
                else
                {
                    scene.events.emit("incorrect");
                }
            }
        }
    }
}

function differentClick(scene,donut)
{
    scene.selector1.setFrame(donut.selectorFrame);
    scene.selector1.setPosition(donut.image.x,donut.image.y);
    // scene.selector1.y = donut.yData;
    //console.log(donut.yData,"diff");
    scene.selector1.setAlpha(1);
    setSelectorDonut(1,donut);

    if(donut.answer)
    {
        scene.events.emit("correct");
    }
    else
    {
        scene.events.emit("incorrect");
    }
}

function incorrect(scene)
{
    //console.log("incorrect");

    const timeline = incorrectTimeline(scene);
    timeline.on('complete',()=>{
        resetSelectors(scene);
    });
}

function correct(scene)
{
    //scene.selector1.depth = scene.selector2.depth = -1;
    //console.log(scene.events.listeners('update'))

    const timeline = correctTimeline(scene);

    timeline.on('complete',()=>{
        gameData.questionNum++;
        resetSelectors(scene);
        ABCya.Tweens.addTween(scene.questionText,500,{x:2100},Phaser.Math.Easing.Quadratic.InOut);
        const stuff = donutsOut(scene);
    });
}

function complete(scene)
{
    //scene.events.removeListener('update',selectorUpdateLoop);
    gameData.selectorDonut = [];

    makeDonutStart(scene);
}

function resetSelectors(scene)
{
    // scene.selector1.setAlpha(0);
    // scene.selector2.setAlpha(0);
    ABCya.Tweens.addTween([scene.selector1,scene.selector2],100,{alpha:0});
    scene.selector1.answer = false;
    scene.selector2.answer = false;
}

function setSelectorDonut(clickedState,donut)
{
    if(clickedState === 1)
    {
        gameData.selectorDonut[0] = donut;
    }
    else
    {
        gameData.selectorDonut[1] = donut;
    }
}

export function selectorUpdateLoop()
{
    if(gameData.selectorDonut[0])
    {
        this.selector1.y = gameData.selectorDonut[0].image.y;
    }

    if(gameData.selectorDonut[1])
    {
        this.selector2.y = gameData.selectorDonut[1].image.y;
    }
}